<template>
  <v-card flat>
    <template>
      <v-layout class="my-auto px-4">
        <barcode-scanner v-if="payload.showScanCode" :module="payload.module" v-model="search" :search="search" :scannerPayload="scannerPayload" :disabled="!checkActionPermission(payload.module, CONSTANTS.EDIT)" :loading="scannerFieldLoading"></barcode-scanner>
        <v-text-field v-else solo :label="$t('message.common.search')" class="pa-0" v-model="search" hide-details dense></v-text-field>
      </v-layout>
      <v-card-title class="pa-0 pl-1 mt-1">
        <v-btn color="primary" v-if="payload.addBtnTo && checkActionPermission(payload.module, CONSTANTS.CREATE)" fab x-small id="newbtnTo" :to="payload.addBtnTo" class="ml-3">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <h4>{{ payload.isCustomModules ? payload.moduleTitle : $t(payload.moduleTitle) }}</h4>
        <v-spacer></v-spacer>
        <h6 class="mr-4">{{payload.list.length}} {{ $t('message.common.of') }} {{payload.totalCount}}</h6>
      </v-card-title>
    </template>
    <v-card-text class="mt-2 mb-4">
      <v-card outlined :color="$listHeaderSurface" class="pa-0 mt-0" v-if="payload.itemHeaders && payload.list && payload.list.length && $vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'md' || $vuetify.breakpoint.name == 'lg' || $vuetify.breakpoint.name == 'xl'">
        <v-row class="ma-0">
          <template v-for="(header, index) in payload.itemHeaders">
            <v-col v-if="!isColumnHidden(payload.items[index])" :cols="colWidth(payload.items[index])" :class="payload.items[index].class" :key="index">
              <strong v-if="header === 'message.projects.drawingGroup' && payload.advanceDrawingTypes">{{$t(header)}}</strong>
              <strong v-else-if="header !== 'message.projects.drawingGroup'">{{$t(header)}}</strong>
            </v-col>
          </template>
        </v-row>
      </v-card>
      <div
        v-show="payload.list.length"
        :id="id"
        class="dynamic-scroll-list"
      >
        <template v-if="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'md' || $vuetify.breakpoint.name == 'lg' || $vuetify.breakpoint.name == 'xl'">
          <v-card v-for="(item, itemIdx) in payload.list" :key="`d-${itemIdx}`" :min-height="$vuetify.breakpoint.xs ? '100' : '55'" outlined :color="$listSurface" class="pa-1 mt-1" @click="checkActionPermission(payload.module, CONSTANTS.EDIT) ? payload.editHandler(item) : ''">  <!--:color="$t(payload.moduleTitle) === $t('message.layout.drawing') && item && item.is_completed === 5 ? '#f19e05' : '#e8eaf6'" -->
            <v-card-text class="pa-1" :class="$t(payload.moduleTitle) === $t('message.layout.drawing') && item && item.is_completed === 5 ? 'orange--text text--lighten-2' : ''">
              <v-row>
                <template>
                  <template v-for="(colValues, index) in payload.items">
                    <!-- a column whose `hide` flag/function is true renders nothing; the header row skips it the same way -->
                    <template v-if="isColumnHidden(colValues)"></template>
                    <template v-else-if="colValues.value">
                      <v-col :cols="colWidth(colValues)" :class="colValues.class" :key="index">
                        <div v-if="colValues.isParagraph" class="custom-height" :class="[item[colValues.value] && colValues.value == 'description' && item[colValues.value].length > 100 ? 'd-inline-block': '', colValues.spanClass]">
                          <v-btn v-if="colValues.prefixIconClick && (!colValues.prefixIconCondition || colValues.prefixIconCondition(item))" icon :small="!colValues.prefixIconSize" @click.stop="colValues.prefixIconClick(item)" color="primary" class="mr-1">
                            <v-icon :size="colValues.prefixIconSize">{{ colValues.prefixIcon || 'mdi-eye' }}</v-icon>
                          </v-btn>
                          {{ item[colValues.value] || '-' }}
                        </div>
                        <span v-else :class="colValues.spanClass">
                          <v-btn v-if="colValues.prefixIconClick && (!colValues.prefixIconCondition || colValues.prefixIconCondition(item))" icon :small="!colValues.prefixIconSize" @click.stop="colValues.prefixIconClick(item)" color="primary" class="mr-1">
                            <v-icon :size="colValues.prefixIconSize">{{ colValues.prefixIcon || 'mdi-eye' }}</v-icon>
                          </v-btn>
                          <strong v-if="colValues.label">{{colValues.label}}: </strong> <br v-if="colValues.label" />{{ item[colValues.value] || '-' }}
                        </span>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col :cols="colWidth(colValues)" :class="colValues.class" :key="index">
                        <v-row :class="colValues.rowClass">
                          <template v-for="(subitems, i) in colValues.subItems">
                            <v-col :cols="subitems.cols" :class="subitems.class" :key="i">
                              <template v-if="subitems.value === 'is_completed'">
                                <v-select
                                  v-if="payload.moduleTitle === 'message.layout.drawing'"
                                  class="px-0 pr-2 status-select"
                                  dense
                                  hide-details
                                  outlined
                                  :items="subitems.items"
                                  :label="$t('message.projects.status')"
                                  item-text="text"
                                  item-value="value"
                                  :loading="statusSaving === item.id"
                                  :disabled="statusSaving === item.id"
                                  v-model="item[subitems.value]"
                                  @click.stop=""
                                  @change="saveStatusUpdate(payload.list.indexOf(item))"></v-select>
                                <template v-else>
                                  <span :class="subitems.spanClass" v-if="!payload.itemHeaders"><strong>{{ $t('message.projects.status') }}:</strong> </span><br v-if="!payload.itemHeaders" />
                                  <span :class="subitems.spanClass">{{item[subitems.value] === 1 ? $t('message.customModule.completed') : $t('message.customModule.notCompleted') }}</span>
                                </template>
                                </template>
                                <template v-else-if="subitems.isTranslatable">
                                <span :class="subitems.spanClass">{{ $t(item[subitems.value]) }}</span>
                              </template>
                              <span v-else :class="subitems.spanClass">{{$t(item[subitems.value])}}</span>
                            </v-col>
                          </template>
                        </v-row>
                      </v-col>
                    </template>
                  </template>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-else>
          <v-card v-for="(item, itemIdx) in payload.list" :key="`m-${itemIdx}`" outlined class="pa-0 mt-2 overflow-x-hidden" :color="$listSurface" @click="checkActionPermission(payload.module, CONSTANTS.EDIT) ? payload.editHandler(item) : ''">
            <v-card-text class="pa-0 px-2 my-2">
              <template v-for="(colValues, index) in payload.items">
                <v-row v-if="!isColumnHidden(colValues)" :key="index" class="pt-1 mt-0 align-center">
                  <v-col :cols="12" class="pa-0"  v-if="payload.itemHeaders && payload.itemHeaders.length">
                    <strong v-if="payload.itemHeaders[index] === 'message.projects.drawingGroup' && payload.advanceDrawingTypes" >{{$t(payload.itemHeaders[index])}}</strong>
                    <strong v-else-if="payload.itemHeaders[index] !== 'message.projects.drawingGroup'">{{ $t(payload.itemHeaders[index]) }}</strong>
                  </v-col>
                  <v-col :cols="12" class="pa-0" :class="$t(payload.moduleTitle) === $t('message.layout.drawing') && item && item.is_completed === 5 ? 'orange--text text--lighten-2' : ''">
                    <template v-if="colValues.value">
                      <div v-if="colValues.isParagraph" class="mx-2 ">
                        <v-btn v-if="colValues.prefixIconClick && (!colValues.prefixIconCondition || colValues.prefixIconCondition(item))" icon :small="!colValues.prefixIconSize" @click.stop="colValues.prefixIconClick(item)" color="primary" class="mr-1 scroll-list-preview-btn">
                          <v-icon :size="colValues.prefixIconSize">{{ colValues.prefixIcon || 'mdi-eye' }}</v-icon>
                        </v-btn>
                        {{item[colValues.value] || "-" }}
                      </div>
                      <span v-else :class="colValues.spanClass" class="mx-2" >
                        <v-btn v-if="colValues.prefixIconClick && (!colValues.prefixIconCondition || colValues.prefixIconCondition(item))" icon :small="!colValues.prefixIconSize" @click.stop="colValues.prefixIconClick(item)" color="primary" class="mr-1 scroll-list-preview-btn">
                          <v-icon :size="colValues.prefixIconSize">{{ colValues.prefixIcon || 'mdi-eye' }}</v-icon>
                        </v-btn>
                        <strong v-if="colValues.label">{{colValues.label}}: </strong> <br v-if="colValues.label" />{{ item[colValues.value] || "-" }}
                      </span>
                    </template>
                    <template v-else>
                      <v-row :class="colValues.rowClass">
                        <template v-for="(subitems, i) in colValues.subItems">
                          <v-col :cols="subitems.cols" :class="subitems.class" :key="i">
                            <template v-if="subitems.value === 'is_completed'">
                              <v-select
                                v-if="payload.moduleTitle === 'message.layout.drawing'"
                                class="px-0 pr-2 status-select"
                                dense
                                hide-details
                                outlined
                                :items="subitems.items"
                                :label="$t('message.projects.status')"
                                item-text="text"
                                item-value="value"
                                :loading="statusSaving === item.id"
                                :disabled="statusSaving === item.id"
                                v-model="item[subitems.value]"
                                @click.stop=""
                                @change="saveStatusUpdate(payload.list.indexOf(item))"></v-select>
                              <template v-else>
                                <span class="mx-2" :class="subitems.spanClass" v-if="!payload.itemHeaders"><strong>{{ $t('message.projects.status') }}:</strong> </span><br v-if="!payload.itemHeaders" />
                                <span class="mx-2" :class="subitems.spanClass">{{item[subitems.value] === 1 ? $t('message.customModule.completed') : $t('message.customModule.notCompleted') }}</span>
                              </template>
                              </template>
                              <template v-else-if="subitems.isTranslatable">
                              <span class="mx-2" :class="subitems.spanClass">{{ $t(item[subitems.value]) }}</span>
                            </template>
                            <span v-else class="mx-2" :class="subitems.spanClass">{{$t(item[subitems.value])}}</span>
                          </v-col>
                        </template>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </template>
      </div>
      <p class="text-center px-5 py-0">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          v-if="payload.loading"
          height="6"
        ></v-progress-linear>
        <v-progress-circular
          indeterminate
          color="primary"
          class="mx-auto"
          v-if="false"
        ></v-progress-circular>
      </p>
      <v-alert prominent text v-if="!payload.loading && (payload.list.length === 0)" type="info" class="mt-2" >
        <v-row align="center">
          <v-col class="grow">{{ $t('message.common.noResults') }}</v-col>
        </v-row>
      </v-alert>
    </v-card-text>
  </v-card>
</template>
<script>
import PermissionsMixin from '@/mixins/permissions'
import { mapGetters } from 'vuex'
import { hostAppApi } from '@/plugins/axios_settings'
export default {
  mixins: [PermissionsMixin],
  props: ['payload', 'id'],
  data () {
    return {
      search: '',
      debouncedSearch: null,
      bottom: false,
      scannerPayload: {
        placeholder: 'message.mixed.scanSerialNumber',
        change: (this.payload.module === 'equipment' || this.payload.module === 'projectequipment') ? this.getRespectiveEquipment : this.getRespectiveChemical,
        attrRef: 'scannerFieldFocus',
        attrId: 'scannerField'
      },
      scannerFieldLoading: false,
      /* Drawings inline status select: id of the row whose save is in flight,
         and the last value the server is known to hold per row id (for revert). */
      statusSaving: null,
      statusPrevious: {}
    }
  },
  components: {
    'barcode-scanner': () => import('@/components/BarQrCodeScanner')
  },
  computed: {
    ...mapGetters(['getHostRefApi', 'userId']),
    paginationInfo () {
      return this.recordsInfo
    }
  },
  mounted () {
    // search after some ms
    this.debouncedSearch = this.$formatter.debounce(() => {
      this.$eventBus.$emit('loadList', this.search)
    }, 750)

    // check if id loaded then do the below
    const el = document.getElementById(this.id)
    if (el && !this.payload.listenerAdded) {
      el.addEventListener('scroll', () => {
        this.bottom = this.bottomVisible()
      })
      this.payload.listenerAdded = true
    }
  },
  methods: {
    /* Column config helpers. `hide` and `cols` may be a plain value or a
       function of the payload, so a list can react to data that arrives after
       the column config was built (e.g. Drawings' advanceDrawingTypes). */
    isColumnHidden (col) {
      if (!col) return false
      return typeof col.hide === 'function' ? !!col.hide(this.payload) : !!col.hide
    },
    colWidth (col) {
      if (!col) return ''
      return typeof col.cols === 'function' ? col.cols(this.payload) : col.cols
    },
    saveStatusUpdate (index) {
      const row = this.payload.list[index]
      const moduleId = row.id
      const newValue = row.is_completed
      const previous = this.statusPrevious[moduleId]

      const header = { 'Content-Type': 'multipart/form-data' }
      const formData = new FormData()
      const url = `${this.getHostRefApi}project_drawing/${moduleId}/drawing_status`
      formData.append('is_completed', newValue)
      formData.append('id', moduleId)
      formData.append('project_id', this.$route.params.project_id)

      this.statusSaving = moduleId
      hostAppApi.post(url, formData, { headers: header })
        .then((response) => {
          this.$set(this.statusPrevious, moduleId, newValue)
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: response.data.message })
        })
        .catch(() => {
          /* Put the row back to what the server still holds, so the list never
             shows a status that was not saved. */
          if (previous !== undefined) this.$set(row, 'is_completed', previous)
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.statusUpdateFailed' })
        })
        .finally(() => {
          this.statusSaving = null
        })
    },
    deleteRecord (id) {
      this.$eventBus.$emit('deleteItems', { module: this.payload.module, id })
    },
    bottomVisible () {
      const el = document.getElementById(this.id)
      if (!el) return false
      const scrollY = el.scrollTop
      const visible = el.clientHeight
      const pageHeight = el.scrollHeight
      const bottomOfPage = visible + scrollY + 1 >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
    /**
     * safePush - Navigates to a new route only if it's different from the current one.
     * Prevents Vue Router's NavigationDuplicated error.
    */
    safePush (path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err
        })
      }
    },
    /* For equipment list scan */
    getRespectiveEquipment () {
      if (this.search) {
        this.scannerFieldLoading = true
        hostAppApi.get(`${this.getHostRefApi}equipment/get_by_barcode/${this.search}`)
          .then((response) => {
            if (response && response.data && typeof response.data === 'number') {
              this.safePush(`/equipments/${response.data}`)
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: 'message.mixed.noEquipmentFound' })
            }
          })
          .finally(() => { this.scannerFieldLoading = false })
      }
    },
    getRespectiveChemical () {
      if (this.search) {
        this.scannerFieldLoading = true
        hostAppApi.get(`${this.getHostRefApi}chemicallist/get_by_barcode/${this.search}`)
          .then((response) => {
            if (response && response.data && typeof response.data === 'number') {
              this.safePush(`/chemicallist/${response.data}`)
            } else {
              if (this.payload.module === 'chemicallist') this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: 'message.mixed.noChemicalFound' })
              else this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: 'message.common.noResults' })
            }
          })
          .finally(() => { this.scannerFieldLoading = false })
      }
    },
    getItemHeight (id) {
      if (this.$vuetify.breakpoint.xs) {
        if (id === 'chemicallistScrollList') {
          return '135'
        } else if (id === 'deviationScrollList') {
          return '170'
        } else if (id === 'weldLogScrollList' || id === 'PWHTScrollList') {
          return '270'
        } else if (id === 'equipmentScrollList' || id === 'customModuleScrollList' || id === 'WPSScrollList' || id === 'equipmentScrollList' || id === 'PWPSScrollList') {
          return '185'
        } else if (id === 'surfaceReportScrollList' || id === 'technicalReportScrollList' || id === 'weldLogScrollList') {
          return '220'
        } else if (id === 'matrialListScrollList' || id === 'ndtScrollList') {
          return '225'
        } else if (id === 'pressureReportScrollList') {
          return '230'
        } else if (id === 'drawingScrollList') {
          return '290'
        } else {
          return '100'
        }
      } else {
        return this.payload.width
      }
    }
  },
  watch: {
    /* Seed the revert baseline for the Drawings status select whenever rows
       arrive (initial load, infinite-scroll append, reload after delete). */
    'payload.list': {
      immediate: true,
      handler (list) {
        if (!Array.isArray(list)) return
        list.forEach(row => {
          if (row && row.id !== undefined && this.statusPrevious[row.id] === undefined) {
            this.$set(this.statusPrevious, row.id, row.is_completed)
          }
        })
      }
    },
    search (val) {
      if (!this.payload.showScanCode) this.debouncedSearch()
    },
    bottom (val) {
      if (val) {
        if (this.payload.list.length !== this.payload.totalCount) this.$eventBus.$emit('loadList', this.search)
      }
    }
  },
  beforeDestroy () {}
}
</script>
<style scoped>
  .custom-height {
    position: relative;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1px;
    word-break: break-word;
  }
  .dynamic-scroll-list {
    max-height: 95vh;
    overflow-y: auto;
  }
  /* Inline status select (Drawings): touch-sized from tablet up. Left at 40px
     below 600px because the stacked phone card is a fixed 290px (getItemHeight)
     and would overflow. Raising it there means raising that number too. */
  @media (min-width: 600px) {
    .status-select ::v-deep .v-input__slot {
      min-height: 48px;
    }
    .status-select ::v-deep .v-select__selections {
      min-height: 46px;
    }
    .status-select ::v-deep .v-label {
      top: 14px;
    }
    .status-select ::v-deep .v-label--active {
      transform: translateY(-20px) scale(0.75);
    }
    .status-select ::v-deep .v-input__append-inner {
      margin-top: 12px;
    }
  }
</style>
